/* eslint-disable @next/next/no-img-element */
import React, { Fragment } from 'react';
import { PlayerDetailItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import Link from 'next/link';
import CountryFlag from 'react-country-flag';
import { getCountryISO2 } from '@amf/shared/utils/country';
import Container from '@amf/shared/components/layout/Container';
import { getInitials } from '@amf/shared/utils/string';

interface PlayerHeaderProps {
  player: PlayerDetailItemFragment;
  prefixes: { team: string };
}

function PlayerHeader({ player, prefixes }: PlayerHeaderProps) {
  const { t } = useTranslate();

  return (
    <div className='mt-40 sm:mt-56'>
      <Container>
        <div className='flex flex-col sm:flex-row items-center gap-8'>
          <div className='w-24 h-24 rounded-full overflow-hidden border border-zinc-200'>
            {player.photoUrl && (
              <img className='w-full h-full' src={player.photoUrl} alt={player.fullName} />
            )}
            {!player.photoUrl && (
              <div className='w-full h-full bg-neutral-200 text-4xl flex items-center justify-center text-neutral-400 font-bold'>
                {getInitials(player.givenName, player.familyName)}
              </div>
            )}
          </div>
          <div className='text-center sm:text-left flex-grow'>
            <h1 className='before:hidden m-0 font-black text-3xl sm:text-6xl font-primary text-black block text-center sm:text-left'>
              {player.fullName}
            </h1>
            <p className='text-lg text-zinc-600 text-center sm:text-left'>
              <CountryFlag svg countryCode={getCountryISO2(player.birthCountry)} />{' '}
              {player.birthCountry} / {t('player.info.age', { age: player.age })} /{' '}
              {player.allCurrentTeams.map(team => (
                <Link key={team.id} href={`${prefixes.team}/${team.id}`} passHref>
                  <a>{team.name}</a>
                </Link>
              ))}
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default PlayerHeader;
